import cloneDeep from 'lodash/fp/cloneDeep';
import integrationService from '../service/integrationService';
import log from '../service/log';
import i18n from '../i18n';
import variants from '@/utils/enums/alertVariants';

const initialState = {
  leadEmailSettings: {},
};

const mutations = {
  SET_EMAIL_SETTINGS(state, data) {
    state.leadEmailSettings = data;
  },
};

const getters = {};

const actions = {
  async getEmailSettings({ commit, rootState }) {
    try {
      // const res = { data: require('@/mock/leadEmailSettings.json') };
      const res = await integrationService.getIntegrationEmailSettings(rootState.business.currentIntegration.id);
      commit('SET_EMAIL_SETTINGS', res.data);
    } catch (error) {
      log(error);
      commit(
        'SET_MESSAGE',
        {
          message: { msgHasLink: false, msg1: i18n.global.t('alerts.generalError') },
          variant: variants.DANGER,
        },
        { root: true }
      );
    }
  },
  async updateEmailSettings({ commit, rootState }, payload) {
    try {
      const res = await integrationService.setIntegrationEmailSettings(
        rootState.business.currentIntegration.id,
        payload
      );
      commit(
        'SET_MESSAGE',
        {
          message: { msgHasLink: false, msg1: i18n.global.t('alerts.savedChanges') },
          variant: variants.SUCCESS,
        },
        { root: true }
      );
      commit('SET_EMAIL_SETTINGS', res.data);
    } catch (error) {
      if (error.response?.status === 409 && error.response?.data?.errorCode === 1001) {
        return { stale: true };
      }
      log(error);
      commit(
        'SET_MESSAGE',
        {
          message: { msgHasLink: false, msg1: i18n.global.t('alerts.generalError') },
          variant: variants.DANGER,
        },
        { root: true }
      );
    }
  },
};

export default {
  namespaced: true,
  state: cloneDeep(initialState),
  getters,
  actions,
  mutations,
};
